import React from 'react';
import { Card, Typography, Button, Tooltip } from 'antd';
import { RightOutlined } from '@ant-design/icons';
import { useResponsiveSizes } from '../../hooks/use-responsive-sizes';

const { Text } = Typography;

interface QuickAccessItem {
  key: string;
  title: string;
  description: string;
  icon: React.ReactNode;
  onClick: () => void;
  disabled?: boolean;
}

interface QuickAccessProps {
  items: QuickAccessItem[];
}

export const QuickAccess: React.FC<QuickAccessProps> = ({ items }) => {
  const { fontSize, spacing } = useResponsiveSizes();

  return (
    <div style={{ flex: 1 }}>
      <Typography.Title style={{ textAlign: 'left', fontSize: fontSize.xl }}>Accesos rápidos</Typography.Title>
      <Card>
        {items.map((item, index) => (
          <Button
            key={item.key}
            type='text'
            onClick={item.onClick}
            disabled={item.disabled}
            style={{
              width: '100%',
              height: 'auto',
              padding: `${spacing.sm}px`,
              marginBottom: spacing.xs,
              textAlign: 'left',
              backgroundColor: index % 2 === 0 ? '#fafafa' : 'transparent',
              border: 'none',
              borderRadius: '8px',
              cursor: item.disabled ? 'not-allowed' : 'pointer',
              opacity: item.disabled ? 0.6 : 1
            }}
          >
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                width: '100%',
                gap: spacing.md
              }}
            >
              <div style={{ display: 'flex', alignItems: 'center', gap: spacing.md, flex: 1, minWidth: 0 }}>
                {item.icon}
                <Tooltip title={item.disabled ? 'Próximamente' : ''} placement='right'>
                  <div style={{ minWidth: 0, flex: 1 }}>
                    <Text strong style={{ fontSize: fontSize.base, display: 'block' }}>
                      {item.title}
                    </Text>
                    <Text type='secondary' style={{ fontSize: fontSize.sm, display: 'block' }}>
                      {item.description}
                    </Text>
                  </div>
                </Tooltip>
              </div>
              {!item.disabled && <RightOutlined style={{ color: '#999', flexShrink: 0 }} />}
            </div>
          </Button>
        ))}
      </Card>
    </div>
  );
};

export default QuickAccess;
